import React, { useEffect, useState } from "react";
import logo from "../assets/logo.jpg";
import { translateToMarathi } from "../utils/marathiTranslator";
const numberToMarathiWords = (num) => {
  if (!num || isNaN(num) || num <= 0) return "शून्य";
  const belowTwenty = ["", "एक", "दोन", "तीन", "चार", "पाच", "सहा", "सात", "आठ", "नऊ", "दहा",
    "अकरा", "बारा", "तेरा", "चौदा", "पंधरा", "सोळा", "सतरा", "अठरा", "एकोणीस"];
  const tens = ["", "", "वीस", "तीस", "चाळीस", "पन्नास", "साठ", "सत्तर", "ऐशी", "नव्वद"];
  const hundreds = ["", "एकशे", "दोनशे", "तीनशे", "चारशे", "पाचशे", "सहाशे", "सातशे", "आठशे", "नऊशे"];
  const scales = ["", "हजार", "लाख", "कोटी"];
  const convertLessThanThousand = (n) => {
    if (n === 0) return "";
    if (n < 20) return belowTwenty[n];
    if (n < 100) return tens[Math.floor(n/10)] + (n%10 > 0 ? " " + belowTwenty[n%10] : "");
    return hundreds[Math.floor(n/100)] + (n%100 > 0 ? " " + convertLessThanThousand(n%100) : "");
  };
  let result = "", scaleIndex = 0, tempNum = Math.floor(Math.abs(Number(num)));
  while (tempNum > 0) {
    const chunk = scaleIndex === 0 ? tempNum % 1000 : tempNum % 100;
    tempNum = scaleIndex === 0 ? Math.floor(tempNum / 1000) : Math.floor(tempNum / 100);
    if (chunk > 0) {
      let chunkWords = convertLessThanThousand(chunk);
      if (scaleIndex > 0) chunkWords += " " + scales[scaleIndex];
      result = chunkWords + (result ? " " + result : "");
    }
    scaleIndex++;
    if (scaleIndex > 3) break;
  }
  return result.trim() + " रुपये";
};
/* ================= TRANSLITERATION ================= */

const toMarathi = async (text) => {
  if (!text) return "";

  try {
    const res = await fetch(
      `https://inputtools.google.com/request?text=${encodeURIComponent(
        text
      )}&itc=mr-t-i0-und&num=1`
    );

    const data = await res.json();

    if (data[0] === "SUCCESS") {
      return data[1][0][1][0];
    }

    return text;
  } catch {
    return text;
  }
};

/* ================= NUMBER ================= */

const toMarathiNumber = (num) => {
  if (num === null || num === undefined) return "";
  return num.toString().replace(/\d/g, (d) => "०१२३४५६७८९"[d]);
};

const RTIPrint = ({ data, onClose }) => {
  const [mrData, setMrData] = useState({});
  const [ready, setReady] = useState(false);

  const mode = data.mode || "EN"; // ✅ IMPORTANT

  const copiesEN = [
    "Receipt (Copy for Concerned Department)",
    "Receipt (Copy for Concerned Payee)",
    "Receipt (Office Copy)",
  ];

  const copiesMR = [
    "पावती (संबंधित विभागासाठी प्रत)",
    "पावती (अर्जदारासाठी प्रत)",
    "पावती (कार्यालयीन प्रत)",
  ];
const formatDate = (date) => {
  if (!date) return "";
  const d = new Date(date);

  const day = String(d.getDate()).padStart(2, "0");
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const year = d.getFullYear();

  return `${day}/${month}/${year}`;
};
  /* ================= CONVERT ================= */

  useEffect(() => {
    if (mode === "MR") {
      const convert = async () => {
        const converted = {
  // payee_name: await toMarathi(data.payee_name),
  bank_name: translateToMarathi(data.bank_name || ""),
  description: await toMarathi(data.description),
  payment_mode: await toMarathi(data.payment_mode),
  amount_words_marathi: numberToMarathiWords(data.amount),  // ← proper marathi words
  reference_no: await toMarathi(data.reference_no),
  reference_date: formatDate(data.reference_date),           // ← was missing
  receipt_date: formatDate(data.receipt_date),               // ← no toMarathi needed
  remark: await toMarathi(data.remark),
};

        setMrData(converted);
        setReady(true);
      };

      convert();
    } else {
      setReady(true);
    }
  }, [data, mode]);

  /* ================= PRINT ================= */

  useEffect(() => {
    if (ready) {
      setTimeout(() => {
        window.print();
        // onClose?.();
      }, 600);
    }
  }, [ready, onClose]);
  if (!ready) return null;

  return (
    <div className="print-container">

      <div className="a4-page receipt-page">

        {/* ================= ENGLISH ================= */}
        {mode === "EN" &&
          copiesEN.map((title, i) => (
            <div key={i} className="receipt">

              <div className="receipt-header">
                <img src={logo} alt="logo" className="logo" />

                <h2>Dharavi Redevelopment Project</h2>
                <p>Slum Rehabilitation Authority</p>
                <p>4th Floor, Gala Altazza, Udyog Nagar, Flank Road</p>
                <p>Beside Shanmukhanand Auditorium, Kings Circle, Sion, Mumbai-400022</p>
              </div>

              <div className="receipt-title">{title}</div>

              <div className="receipt-body">
                <div className="left">
                  <div className="row">Receipt No: {data.receipt_no}</div>
                  
                  <div className="row">Amount: Rs.{data.amount}/-</div>
                  <div className="row">Payee Name: {data.payee_name}</div>
                  {/* <div className="row">By: {data.payment_mode}</div> */}
                  <div className="row">
  By: {
    data.payment_mode === "neft"
      ? "NEFT"
      : data.payment_mode === "cash"
      ? "Cash"
      : data.payment_mode === "dd"
      ? "DD"
      : data.payment_mode === "cheque"
      ? "Cheque"
      : data.payment_mode
  }
</div>
                  <div className="row">Bank Name: {data.bank_name || "Nil"}</div>

                  <div className="row">
  Remark: {data.remark || "-"}
</div>

                  <div className="amount-box">Rs.{data.amount}/-</div>
                </div>

                <div className="right">
                  <div className="row">
  Receipt Date: {formatDate(data.receipt_date)}
</div>

                  <div className="row">
                    Amount in words: {data.amount_words} 
                  </div>

         <div className="row">
  Fee Type Description : {data.description || "RTI Receipt"}
</div>

                 <div className="row">
  {data.payment_mode === "cash" && (
    <>
      Transaction ID: {data.reference_no || "Nil"} <br />
      Transaction Date: {formatDate(data.reference_date) || "Nil"}
    </>
  )}

  {data.payment_mode === "neft" && (
    <>
      NEFT No: {data.reference_no || "Nil"} <br />
      NEFT Date: {formatDate(data.reference_date) || "Nil"}
    </>
  )}

  {(data.payment_mode === "cheque" || data.payment_mode === "dd") && (
    <>
      Cheque/DD No: {data.reference_no || "Nil"} <br />
      Cheque/DD Date: {formatDate(data.reference_date) || "Nil"}
    </>
  )}
</div>
                </div>
              </div>

              <div className="receipt-footer">
                <div>Assistant Account Officer / Cashier</div>
         
                <div className="signature-space"></div>
                       <div>Dharavi Redevelopment Project, Mumbai</div>
              </div>

            </div>
          ))}

        {/* ================= MARATHI ================= */}
        {mode === "MR" &&
          copiesMR.map((title, i) => (
            <div key={i} className="receipt">

              <div className="receipt-header">
                <img src={logo} alt="logo" className="logo" />

                <h2>धारावी पुनर्विकास प्रकल्प</h2>
                <p>झोपडपट्टी पुनर्वसन प्राधिकरण</p>
                <p>चौथा मजला, गाला अल्टाझा, उद्योग नगर, फ्लँक रोड</p>
                <p>शनमुखानंद सभागृहाजवळ, किंग्ज सर्कल, सायन, मुंबई-४०००२२</p>
              </div>

              <div className="receipt-title">{title}</div>

              <div className="receipt-body">
                <div className="left">
                  <div className="row">पावती क्रमांक: {toMarathiNumber(data.receipt_no)}</div>
                  <div className="row">रक्कम: ₹{toMarathiNumber(data.amount)}/-</div>
                  <div className="row">देणाऱ्याचे नाव: {data.payee_name}</div>
                  <div className="row">द्वारे: {mrData.payment_mode}</div>
                  <div className="row">बँकेचे नाव: {mrData.bank_name}</div>

                  <div className="row">
                    नोंद: {mrData.description || "माहिती अधिकार कायदा"}
                  </div>

                  <div className="amount-box">
                    ₹{toMarathiNumber(data.amount)}/-
                  </div>
                </div>

                <div className="right">
                  <div className="row">
                    पावती दिनांक: {mrData.receipt_date}
                  </div>

                  <div className="row">
  शब्दात रक्कम: {mrData.amount_words_marathi}
</div>

                  <div className="row">
                    शुल्क प्रकार: {mrData.description || "RTI पावती"}
                  </div>

                <div className="row">
  {data.payment_mode === "cash" && (
  <>
    व्यवहार क्रमांक: {mrData.reference_no || "शून्य"} <br />
    व्यवहार दिनांक: {mrData.reference_date || "शून्य"}   {/* ← now works */}
  </>
)}

{data.payment_mode === "neft" && (
  <>
    NEFT क्रमांक: {mrData.reference_no || "शून्य"} <br />
    NEFT दिनांक: {mrData.reference_date || "शून्य"}       {/* ← now works */}
  </>
)}

{(data.payment_mode === "cheque" || data.payment_mode === "dd") && (
  <>
    धनादेश क्रमांक: {mrData.reference_no || "शून्य"} <br />
    धनादेश दिनांक: {mrData.reference_date || "शून्य"}    {/* ← now works */}
  </>
)}
</div>
                </div>
              </div>

              <div className="receipt-footer">
                <div>सहाय्यक लेखाधिकारी / रोखपाल</div>
                <div className="signature-space"></div>
                <div>धारावी पुनर्विकास प्रकल्प, मुंबई</div>
              </div>

            </div>
          ))}

      </div>

    </div>
  );
};

export default RTIPrint;
